import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PatientSafetyNotificationComponent } from '../patient-safety-notification/patient-safety-notification.component';

const routes: Routes = [
  {
    path: '',
    component: PatientSafetyNotificationComponent,
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PatientSafetyNotificationRoutingModule {}
